import "./styles.css";
import "./ui/app.ts";

// ═══════════════════════════════════════
// 龙虾智盒：登录 + 设备扫描 + 用户管理
// 所有业务逻辑在 iframe 内部，Electron 壳子仅桥接
// ═══════════════════════════════════════

const API_BASE = (window as any).__LX_API_BASE || `${location.protocol}//clawdbox-api.xiaosuanyun.com`;

// macOS 检测
if (navigator.platform.includes("Mac") || navigator.userAgent.includes("Macintosh")) {
  document.documentElement.classList.add("is-macos");
}

// ── 工具函数 ──
function isLoggedIn(): boolean {
  return !!localStorage.getItem("lx_token");
}
function isGuest(): boolean {
  return localStorage.getItem("lx_is_guest") === "1";
}
function getUser(): Record<string, string> {
  try { return JSON.parse(localStorage.getItem("lx_user") || "{}"); } catch { return {}; }
}

// ── 注入全局样式（弹窗）──
const globalStyle = document.createElement("style");
globalStyle.textContent = `
  .lx-overlay { display:none; position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.6); backdrop-filter:blur(4px); z-index:9000; align-items:center; justify-content:center; }
  .lx-overlay.show { display:flex; }

  /* 登录弹窗 */
  .lx-login-card { display:flex; width:820px; max-width:95%; height:700px; border-radius:16px; overflow:hidden; box-shadow:0 16px 48px rgba(0,0,0,0.25); position:relative; }
  .lx-login-left { width:45%; background:linear-gradient(135deg,#1a1a2e,#16213e,#0f3460); display:flex; flex-direction:column; align-items:center; justify-content:center; position:relative; overflow:hidden; }
  .lx-login-left::before { content:''; position:absolute; inset:0; opacity:0.06; background:repeating-linear-gradient(0deg,transparent,transparent 39px,rgba(255,255,255,0.03) 39px,rgba(255,255,255,0.03) 40px),repeating-linear-gradient(90deg,transparent,transparent 39px,rgba(255,255,255,0.03) 39px,rgba(255,255,255,0.03) 40px); }
  .lx-orb { position:relative; width:180px; height:180px; margin-bottom:24px; }
  .lx-orb-glow { position:absolute; inset:-20px; border-radius:50%; background:radial-gradient(circle,rgba(217,119,6,0.3) 0%,transparent 70%); animation:lx-pulse 3s ease-in-out infinite; }
  @keyframes lx-pulse { 0%,100% { opacity:0.6; transform:scale(1); } 50% { opacity:1; transform:scale(1.05); } }
  .lx-orb-circle { position:relative; width:100%; height:100%; border-radius:50%; background:rgba(255,255,255,0.03); border:1px solid rgba(255,255,255,0.08); display:flex; align-items:center; justify-content:center; }
  .lx-orb-ring1 { position:absolute; inset:12px; border-radius:50%; border:1px solid rgba(217,119,6,0.15); animation:lx-spin 16s linear infinite; }
  .lx-orb-ring2 { position:absolute; inset:30px; border-radius:50%; border:1px dashed rgba(217,119,6,0.1); animation:lx-spin 22s linear infinite reverse; }
  @keyframes lx-spin { to { transform:rotate(360deg); } }
  .lx-orb img { width:72px; height:72px; border-radius:16px; position:relative; z-index:1; }
  .lx-login-left h1 { color:#fff; font-size:22px; font-weight:700; position:relative; z-index:1; }
  .lx-login-left p { color:rgba(255,255,255,0.5); font-size:12px; margin-top:6px; position:relative; z-index:1; }
  .lx-login-right { flex:1; background:#fff; display:flex; flex-direction:column; position:relative; }
  .lx-login-close { position:absolute; top:12px; right:14px; border:none; background:transparent; font-size:20px; cursor:pointer; color:#bbb; z-index:2; width:32px; height:32px; border-radius:50%; display:flex; align-items:center; justify-content:center; }
  .lx-login-close:hover { background:#f5f5f5; color:#333; }
  .lx-login-body { flex:1; display:flex; flex-direction:column; justify-content:center; padding:0 32px; }
  .lx-login-body h2 { font-size:22px; font-weight:700; color:#1A1915; margin-bottom:4px; }
  .lx-login-body .sub { font-size:13px; color:#9C9589; margin-bottom:20px; }
  .lx-tabs { display:flex; background:#f1f3f5; border-radius:10px; padding:3px; margin-bottom:20px; }
  .lx-tab { flex:1; padding:9px; text-align:center; font-size:13px; font-weight:500; border:none; background:transparent; cursor:pointer; border-radius:8px; color:#6B6560; }
  .lx-tab.active { background:#fff; color:#D97706; box-shadow:0 1px 3px rgba(0,0,0,0.08); }
  .lx-field { margin-bottom:14px; }
  .lx-field label { display:block; font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:0.05em; color:#9C9589; margin-bottom:5px; }
  .lx-field input { width:100%; padding:11px 14px; border:1px solid #e5e0d8; border-radius:10px; font-size:14px; outline:none; background:#fafafa; }
  .lx-field input:focus { border-color:#D97706; background:#fff; }
  .lx-code-row { display:flex; gap:10px; }
  .lx-code-row input { flex:1; }
  .lx-code-btn { padding:11px 16px; border:1px solid rgba(217,119,6,0.3); background:rgba(217,119,6,0.05); color:#D97706; border-radius:10px; font-size:13px; cursor:pointer; white-space:nowrap; }
  .lx-code-btn:disabled { opacity:0.5; cursor:not-allowed; }
  .lx-submit { width:100%; padding:13px; border:none; background:linear-gradient(135deg,#D97706,#b45309); color:#fff; font-size:15px; font-weight:600; border-radius:10px; cursor:pointer; margin-top:6px; }
  .lx-submit:disabled { opacity:0.6; cursor:not-allowed; }
  .lx-error { background:rgba(229,57,53,0.08); border:1px solid rgba(229,57,53,0.2); color:#e53935; padding:10px 14px; border-radius:10px; font-size:13px; margin-bottom:14px; display:none; }
  .lx-footer { padding:14px 32px; text-align:center; font-size:10px; color:#bbb; border-top:1px solid #f1f3f5; margin-top:auto; }
  .lx-footer a { color:rgba(217,119,6,0.6); text-decoration:none; }

  /* 扫描弹窗 */
  .lx-radar-dialog { background:#FAF9F6; border-radius:16px; padding:30px; box-shadow:0 16px 48px rgba(0,0,0,0.2); text-align:center; position:relative; }
  .lx-radar-close { position:absolute; top:12px; right:16px; border:none; background:transparent; font-size:20px; cursor:pointer; color:#999; }
  .lx-radar-dialog h2 { font-size:18px; font-weight:700; margin-bottom:16px; color:#1A1915; }
  .lx-radar-wrap { position:relative; width:340px; height:340px; margin:0 auto; }
  .lx-radar-wrap canvas { width:100%; height:100%; border-radius:50%; }
  .lx-device-icon { position:absolute; width:44px; height:44px; border-radius:50%; background:rgba(217,119,6,0.08); border:2px solid #D97706; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:transform 0.3s,box-shadow 0.3s; transform:translate(-50%,-50%) scale(0); z-index:2; }
  .lx-device-icon.visible { transform:translate(-50%,-50%) scale(1); }
  .lx-device-icon:hover { transform:translate(-50%,-50%) scale(1.15); box-shadow:0 0 24px rgba(217,119,6,0.3); }
  .lx-device-icon svg { width:20px; height:20px; fill:#D97706; }
  .lx-device-label { position:absolute; top:48px; left:50%; transform:translateX(-50%); font-family:monospace; font-size:9px; color:#B8A080; white-space:nowrap; pointer-events:none; }
  .lx-hint { color:#9C9589; font-size:13px; margin-top:12px; }
  .lx-count { font-family:monospace; font-size:12px; color:#9C9589; margin-top:4px; }
  .lx-count em { color:#D97706; font-style:normal; font-weight:600; }

  /* 通用对话框 */
  .lx-dialog-overlay { display:none; position:fixed; inset:0; z-index:9999; align-items:center; justify-content:center; background:rgba(0,0,0,0.5); backdrop-filter:blur(4px); }
  .lx-dialog-overlay.show { display:flex; }
  .lx-dialog-card { width:340px; padding:28px 24px 20px; border-radius:20px; background:#fff; box-shadow:0 20px 60px rgba(0,0,0,0.15); display:flex; flex-direction:column; align-items:center; gap:16px; animation:lx-dialog-in 0.25s cubic-bezier(0.16,1,0.3,1); }
  @keyframes lx-dialog-in { from { opacity:0; transform:scale(0.9) translateY(10px); } to { opacity:1; transform:none; } }
  .lx-dialog-icon { width:48px; height:48px; border-radius:14px; display:flex; align-items:center; justify-content:center; font-size:24px; }
  .lx-dialog-icon.alert { background:rgba(217,119,6,0.1); color:#D97706; }
  .lx-dialog-icon.confirm { background:rgba(251,191,36,0.12); color:#f59e0b; }
  .lx-dialog-msg { font-size:14px; line-height:1.6; color:#1A1915; text-align:center; word-break:break-word; }
  .lx-dialog-actions { display:flex; gap:10px; width:100%; margin-top:4px; }
  .lx-dialog-btn { flex:1; padding:10px 0; border-radius:12px; font-size:14px; font-weight:600; cursor:pointer; border:none; outline:none; transition:all 0.2s; }
  .lx-dialog-btn.cancel { background:#f1f3f5; color:#6B6560; border:1px solid #e5e0d8; }
  .lx-dialog-btn.cancel:hover { background:#e9ecef; color:#1A1915; }
  .lx-dialog-btn.ok { background:linear-gradient(135deg,#D97706,#b45309); color:#fff; box-shadow:0 2px 12px rgba(217,119,6,0.3); }
  .lx-dialog-btn.ok:hover { box-shadow:0 4px 20px rgba(217,119,6,0.5); }

  /* 右上角 Toast 通知 */
  .lx-toast-container { position:fixed; top:16px; right:16px; z-index:8000; display:flex; flex-direction:column; gap:8px; pointer-events:none; }
  .lx-toast { pointer-events:auto; display:flex; align-items:flex-start; gap:10px; padding:12px 16px; min-width:280px; max-width:380px; background:#fff; border-radius:12px; box-shadow:0 8px 32px rgba(0,0,0,0.12),0 2px 8px rgba(0,0,0,0.06); border-left:3px solid #D97706; transform:translateX(120%); opacity:0; transition:transform 0.35s cubic-bezier(0.16,1,0.3,1),opacity 0.35s ease; }
  .lx-toast.show { transform:translateX(0); opacity:1; }
  .lx-toast.hide { transform:translateX(120%); opacity:0; }
  .lx-toast-icon { font-size:20px; flex-shrink:0; margin-top:1px; }
  .lx-toast-body { flex:1; min-width:0; }
  .lx-toast-title { font-size:13px; font-weight:700; color:#1A1915; margin-bottom:2px; }
  .lx-toast-msg { font-size:12px; color:#6B6560; line-height:1.4; word-break:break-word; }
  .lx-toast-time { font-size:10px; color:#9C9589; margin-top:4px; }
  .lx-toast-close { position:absolute; top:8px; right:10px; border:none; background:transparent; font-size:14px; color:#bbb; cursor:pointer; padding:0; line-height:1; }
  .lx-toast-close:hover { color:#333; }
  .lx-toast--success { border-left-color:#3ecf8e; }
  .lx-toast--error { border-left-color:#e53935; }
  .lx-toast--info { border-left-color:#D97706; }
`;
document.head.appendChild(globalStyle);

// ── 注入弹窗 HTML ──
const overlayContainer = document.createElement("div");
overlayContainer.innerHTML = `
  <!-- 登录弹窗 -->
  <div class="lx-overlay" id="lxLoginOverlay">
    <div class="lx-login-card">
      <div class="lx-login-left">
        <div class="lx-orb"><div class="lx-orb-glow"></div><div class="lx-orb-circle"><div class="lx-orb-ring1"></div><div class="lx-orb-ring2"></div><img src="./favicon-32.png" alt=""></div></div>
        <h1>龙虾智盒</h1><p>登录后解锁完整的智能体验</p>
      </div>
      <div class="lx-login-right">
        <button class="lx-login-close" id="lxLoginClose">✕</button>
        <div class="lx-login-body">
          <h2 id="lxLoginTitle">验证码登录</h2>
          <div class="sub" id="lxLoginSub">通过手机验证码快速登录</div>
          <div class="lx-tabs">
            <button class="lx-tab active" id="lxTabPhone">📱 手机号登录</button>
            <button class="lx-tab" id="lxTabWechat">微信登录</button>
          </div>
          <div id="lxError" class="lx-error"></div>
          <div id="lxPhoneForm">
            <div class="lx-field"><label>手机号码</label><input id="lxPhone" type="tel" maxlength="11" placeholder="请输入手机号码"></div>
            <div class="lx-field"><label>验证码</label><div class="lx-code-row"><input id="lxCode" type="text" maxlength="6" placeholder="6位数字"><button class="lx-code-btn" id="lxSendCode">获取验证码</button></div></div>
            <button class="lx-submit" id="lxLoginBtn">登 录</button>
          </div>
          <div id="lxWechatForm" style="display:none;">
            <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;">
              <div id="lxWxLoading" style="padding:40px;color:#9C9589;">加载中...</div>
              <iframe id="lxWxQr" src="" width="300" height="400" style="display:none;border:none;border-radius:8px;"></iframe>
            </div>
          </div>
        </div>
        <div class="lx-footer">登录即代表您同意 <a href="#">服务协议</a> 和 <a href="#">隐私政策</a></div>
      </div>
    </div>
  </div>

  <!-- 扫描弹窗 -->
  <div class="lx-overlay" id="lxRadarOverlay">
    <div class="lx-radar-dialog">
      <button class="lx-radar-close" id="lxRadarClose">✕</button>
      <h2>扫描局域网设备</h2>
      <div class="lx-radar-wrap" id="lxRadarWrap">
        <canvas id="lxRadar" width="340" height="340"></canvas>
      </div>
      <div class="lx-hint">正在扫描...</div>
      <div class="lx-count">发现 <em id="lxDeviceCount">0</em> 台设备</div>
    </div>
  </div>

  <!-- 通用对话框 -->
  <div class="lx-dialog-overlay" id="lxDialogOverlay">
    <div class="lx-dialog-card">
      <div class="lx-dialog-icon alert" id="lxDialogIcon">ℹ️</div>
      <p class="lx-dialog-msg" id="lxDialogMsg"></p>
      <div class="lx-dialog-actions">
        <button class="lx-dialog-btn cancel" id="lxDialogCancel" style="display:none;">取消</button>
        <button class="lx-dialog-btn ok" id="lxDialogOk">确定</button>
      </div>
    </div>
  </div>
`;
document.body.appendChild(overlayContainer);

// ═══════════════════════════════════════
// 通用对话框（替代原生 confirm / alert）
// ═══════════════════════════════════════
let dialogResolve: ((ok: boolean) => void) | null = null;
const dialogOverlay = document.getElementById("lxDialogOverlay")!;
document.getElementById("lxDialogOk")!.onclick = () => { dialogOverlay.classList.remove("show"); dialogResolve?.(true); dialogResolve = null; };
document.getElementById("lxDialogCancel")!.onclick = () => { dialogOverlay.classList.remove("show"); dialogResolve?.(false); dialogResolve = null; };

function lxAlert(msg: string): Promise<void> {
  document.getElementById("lxDialogMsg")!.textContent = msg;
  document.getElementById("lxDialogIcon")!.textContent = "ℹ️";
  document.getElementById("lxDialogIcon")!.className = "lx-dialog-icon alert";
  document.getElementById("lxDialogCancel")!.style.display = "none";
  dialogOverlay.classList.add("show");
  return new Promise((resolve) => { dialogResolve = () => resolve(); });
}

function lxConfirm(msg: string): Promise<boolean> {
  document.getElementById("lxDialogMsg")!.textContent = msg;
  document.getElementById("lxDialogIcon")!.textContent = "⚠️";
  document.getElementById("lxDialogIcon")!.className = "lx-dialog-icon confirm";
  document.getElementById("lxDialogCancel")!.style.display = "";
  dialogOverlay.classList.add("show");
  return new Promise((resolve) => { dialogResolve = resolve; });
}

// ═══════════════════════════════════════
// 登录系统
// ═══════════════════════════════════════
let wxState = "";
let wxPollTimer: ReturnType<typeof setInterval> | null = null;
let wxLoginHandled = false;
let loginCountdown = 0;
let loginCountdownTimer: ReturnType<typeof setInterval> | null = null;
let pendingAuthResolve: ((ok: boolean) => void) | null = null;

const loginOverlay = document.getElementById("lxLoginOverlay")!;
document.getElementById("lxLoginClose")!.onclick = () => closeLogin();
loginOverlay.addEventListener("click", (e) => { if (e.target === loginOverlay) closeLogin(); });
document.getElementById("lxTabPhone")!.onclick = () => switchTab("phone");
document.getElementById("lxTabWechat")!.onclick = () => switchTab("wechat");
document.getElementById("lxSendCode")!.onclick = () => sendCode();
document.getElementById("lxLoginBtn")!.onclick = () => doPhoneLogin();

function openLogin() {
  loginOverlay.classList.add("show");
  wxLoginHandled = false;
  stopWxPoll();
  const qr = document.getElementById("lxWxQr") as HTMLIFrameElement | null;
  const loading = document.getElementById("lxWxLoading");
  if (qr) { qr.src = ""; qr.style.display = "none"; }
  if (loading) { loading.style.display = ""; loading.textContent = "加载中..."; }
  if (document.getElementById("lxTabWechat")?.classList.contains("active")) loadWxQr();
}
function closeLogin() {
  loginOverlay.classList.remove("show");
  stopWxPoll();
  if (pendingAuthResolve) { pendingAuthResolve(isLoggedIn() && !isGuest()); pendingAuthResolve = null; }
}

function switchTab(tab: string) {
  document.getElementById("lxTabPhone")!.classList.toggle("active", tab === "phone");
  document.getElementById("lxTabWechat")!.classList.toggle("active", tab === "wechat");
  document.getElementById("lxPhoneForm")!.style.display = tab === "phone" ? "" : "none";
  document.getElementById("lxWechatForm")!.style.display = tab === "wechat" ? "" : "none";
  (document.getElementById("lxError")! as HTMLElement).style.display = "none";
  document.getElementById("lxLoginTitle")!.textContent = tab === "phone" ? "验证码登录" : "微信登录";
  document.getElementById("lxLoginSub")!.textContent = tab === "phone" ? "通过手机验证码快速登录" : "使用微信扫码登录";
  if (tab === "wechat") loadWxQr();
  else stopWxPoll();
}

function showError(msg: string) { const el = document.getElementById("lxError")!; el.textContent = msg; el.style.display = ""; }

async function sendCode() {
  const phone = (document.getElementById("lxPhone") as HTMLInputElement).value.replace(/\D/g, "");
  if (!/^1\d{10}$/.test(phone)) { showError("请输入正确的手机号"); return; }
  (document.getElementById("lxError")! as HTMLElement).style.display = "none";
  const btn = document.getElementById("lxSendCode") as HTMLButtonElement;
  btn.disabled = true;
  try {
    const res = await fetch(`${API_BASE}/api/v1/auth/sms/send`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ phone }) }).then(r => r.json());
    if (res.code !== 0) throw new Error(res.message || "发送失败");
    loginCountdown = 60;
    btn.textContent = `${loginCountdown}s`;
    loginCountdownTimer = setInterval(() => { loginCountdown--; btn.textContent = `${loginCountdown}s`; if (loginCountdown <= 0) { clearInterval(loginCountdownTimer!); btn.disabled = false; btn.textContent = "获取验证码"; } }, 1000);
  } catch (e: any) { showError(e.message); btn.disabled = false; }
}

async function doPhoneLogin() {
  const phone = (document.getElementById("lxPhone") as HTMLInputElement).value.replace(/\D/g, "");
  const code = (document.getElementById("lxCode") as HTMLInputElement).value.trim();
  if (!phone) { showError("请输入手机号"); return; }
  if (!code) { showError("请输入验证码"); return; }
  (document.getElementById("lxError")! as HTMLElement).style.display = "none";
  const btn = document.getElementById("lxLoginBtn") as HTMLButtonElement;
  btn.disabled = true; btn.textContent = "登录中...";
  try {
    const smsH: Record<string, string> = { "Content-Type": "application/json" };
    const smsTk = localStorage.getItem("lx_token");
    if (smsTk) smsH["Authorization"] = "Bearer " + smsTk;
    const res = await fetch(`${API_BASE}/api/v1/auth/sms/verify`, { method: "POST", headers: smsH, body: JSON.stringify({ phone, code }) }).then(r => r.json());
    if (res.code !== 0 || !res.data?.token) throw new Error(res.message || "登录失败");
    onLoginSuccess(res.data.token, res.data.user);
  } catch (e: any) { showError(e.message); } finally { btn.disabled = false; btn.textContent = "登 录"; }
}

async function loadWxQr() {
  stopWxPoll(); wxLoginHandled = false;
  (document.getElementById("lxWxQr") as HTMLIFrameElement).style.display = "none";
  (document.getElementById("lxWxQr") as HTMLIFrameElement).src = "";
  const loadingEl = document.getElementById("lxWxLoading")!;
  loadingEl.style.display = "";
  loadingEl.textContent = "加载中...";

  try {
    const res = await fetch(`${API_BASE}/api/v1/auth/wechat/qrcode`).then(r => r.json());
    if (res.code !== 0 || !res.data) throw new Error(res.message || "获取二维码失败");
    const { appid, state, redirectUri, scope } = res.data;
    wxState = state;
    const cssHref = encodeURIComponent(`${API_BASE}/wechat-qr.css`);
    const url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${scope}&state=${state}&href=${cssHref}#wechat_redirect`;

    // 直接嵌入 iframe 显示二维码
    (document.getElementById("lxWxQr") as HTMLIFrameElement).src = url;
    loadingEl.style.display = "none";
    (document.getElementById("lxWxQr") as HTMLIFrameElement).style.display = "";

    // 轮询服务器检查登录结果
    wxPollTimer = setInterval(pollWxResult, 2000);
  } catch (e: any) {
    loadingEl.textContent = e.message;
  }
}

async function pollWxResult() {
  if (!wxState || wxLoginHandled) return;
  try {
    const res = await fetch(`${API_BASE}/api/v1/auth/wechat/check?state=${wxState}`).then(r => r.json());
    if (res.code !== 0) return;
    if (res.data.status === "success") { stopWxPoll(); wxLoginHandled = true; onLoginSuccess(res.data.token, res.data.user); }
    else if (res.data.status === "expired") { stopWxPoll(); document.getElementById("lxWxLoading")!.textContent = "二维码已过期"; document.getElementById("lxWxLoading")!.style.display = ""; (document.getElementById("lxWxQr") as HTMLIFrameElement).style.display = "none"; }
  } catch {}
}

function stopWxPoll() {
  if (wxPollTimer) { clearInterval(wxPollTimer); wxPollTimer = null; }
}

window.addEventListener("message", (e) => {
  // 服务端 callback 页面通过 postMessage 直接传回 token（弹窗模式）
  if (typeof e.data === "string") {
    try {
      const parsed = JSON.parse(e.data);
      if (parsed.type === "wx-login-result" && parsed.success && parsed.token && !wxLoginHandled) {
        wxLoginHandled = true; stopWxPoll();
        onLoginSuccess(parsed.token, parsed.user);
        return;
      }
    } catch {}
  }
  // Electron 壳子桥接的微信回调
  if (e.data?.type === "wechat-callback") {
    const { code, state } = e.data;
    if (!code || state !== wxState || wxLoginHandled) return;
    wxLoginHandled = true; stopWxPoll();
    const wxHeaders: Record<string, string> = { "Content-Type": "application/json" };
    const guestTk = localStorage.getItem("lx_token");
    if (guestTk) wxHeaders["Authorization"] = "Bearer " + guestTk;
    fetch(`${API_BASE}/api/v1/auth/wechat/code`, { method: "POST", headers: wxHeaders, body: JSON.stringify({ code, state }) })
      .then(r => r.json()).then(res => {
        if (res.code === 0 && res.data?.token) onLoginSuccess(res.data.token, res.data.user);
        else showError(res.message || "微信登录失败");
      }).catch((err: Error) => showError(err.message));
  }
  // Electron 推送设备列表
  if (e.data?.type === "devices-update") {
    updateRadarDevices(e.data.devices || []);
  }
  // Electron 壳子推送主题切换
  if (e.data?.type === "theme-change" && (e.data.theme === "light" || e.data.theme === "dark")) {
    const app = document.querySelector("oc-app") as any;
    if (app && typeof app.themeMode !== "undefined") {
      app.themeMode = e.data.theme;
      app.themeResolved = e.data.theme === "light" ? "light" : "dark";
      document.documentElement.setAttribute("data-theme-mode", e.data.theme);
      app.requestUpdate();
    }
  }
});

function onLoginSuccess(token: string, user: Record<string, unknown>) {
  localStorage.setItem("lx_token", token);
  localStorage.setItem("lx_user", JSON.stringify(user || {}));
  localStorage.removeItem("lx_is_guest");
  closeLogin();
  updateUserUI();
  startCreditsPolling();
  if (pendingAuthResolve) { pendingAuthResolve(true); pendingAuthResolve = null; }
  // 通知 Electron 壳子（父窗口）更新登录状态，同步 token 和用户信息
  try { window.parent.postMessage({ type: "login-success", token, user }, "*"); } catch {}
}

// ── 积分系统 ──
let creditsTimer: ReturnType<typeof setInterval> | null = null;

function setCreditsDisplay(balance: number) {
  localStorage.setItem("lx_credits", String(balance));
  updateUserUI(); // 触发 Lit 重新渲染，不直接操作 DOM
}

async function fetchCredits() {
  const token = localStorage.getItem("lx_token");
  if (!token || isGuest()) return;
  try {
    const res = await fetch(`${API_BASE}/api/v1/credits`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(r => r.json());
    if (res.code === 0 && res.data) setCreditsDisplay(res.data.balance ?? 0);
  } catch {}
}

async function refreshCredits() {
  const token = localStorage.getItem("lx_token");
  if (!token || isGuest()) return;
  try {
    const res = await fetch(`${API_BASE}/api/v1/credits/refresh`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    }).then(r => r.json());
    if (res.code === 0 && res.data) {
      setCreditsDisplay(res.data.balance ?? 0);
    } else if (res.code === 401) {
      // token 过期，清除登录状态
      console.info("[Credits] token 过期，清除登录状态");
      stopCreditsPolling();
      localStorage.removeItem("lx_token");
      localStorage.removeItem("lx_user");
      localStorage.removeItem("lx_credits");
      localStorage.removeItem("lx_is_guest");
      updateUserUI();
    }
  } catch {}
}

function getCreditsBalance(): number {
  return parseInt(localStorage.getItem("lx_credits") || "0", 10);
}

function hasCredits(): boolean {
  // 游客或未登录不检查积分
  if (!isLoggedIn() || isGuest()) return true;
  // 还没拉取过积分（首次登录），放行，等拉取后再判断
  if (!localStorage.getItem("lx_credits")) return true;
  return getCreditsBalance() > 0;
}

function startCreditsPolling() {
  stopCreditsPolling();
  refreshCredits();
  creditsTimer = setInterval(refreshCredits, 5 * 60 * 1000); // 每 5 分钟刷新
}

function stopCreditsPolling() {
  if (creditsTimer) { clearInterval(creditsTimer); creditsTimer = null; }
}

async function ensureGuest() {
  if (isLoggedIn()) return;
  try {
    const res = await fetch(`${API_BASE}/api/v1/auth/guest`, { method: "POST", headers: { "Content-Type": "application/json" } }).then(r => r.json());
    if (res.code === 0 && res.data?.token) {
      localStorage.setItem("lx_token", res.data.token);
      localStorage.setItem("lx_user", JSON.stringify(res.data.user || {}));
      localStorage.setItem("lx_is_guest", "1");
    }
  } catch {}
}

async function logout() {
  stopCreditsPolling();
  localStorage.removeItem("lx_token"); localStorage.removeItem("lx_user"); localStorage.removeItem("lx_is_guest"); localStorage.removeItem("lx_credits");
  await ensureGuest();
  updateUserUI();
}

async function confirmLogout() {
  const ok = await lxConfirm("确定要退出登录吗？");
  if (ok) logout();
}

// ── 用户 UI 更新（触发 Lit 重新渲染侧边栏）──
function updateUserUI() {
  const app = document.querySelector("openclaw-app") as any;
  if (app?.requestUpdate) app.requestUpdate();
}

// ═══════════════════════════════════════
// 设备扫描
// ═══════════════════════════════════════
const radarOverlay = document.getElementById("lxRadarOverlay")!;
document.getElementById("lxRadarClose")!.onclick = () => radarOverlay.classList.remove("show");
radarOverlay.addEventListener("click", (e) => { if (e.target === radarOverlay) radarOverlay.classList.remove("show"); });

function openRadar() {
  radarOverlay.classList.add("show");
  // 请求 Electron 壳子开始推送设备
  try { window.parent.postMessage({ type: "request-scan" }, "*"); } catch {}
}

// 雷达动画
const radarCanvas = document.getElementById("lxRadar") as HTMLCanvasElement;
const rCtx = radarCanvas.getContext("2d")!;
const RW = 340, RH = 340, RCX = RW / 2, RCY = RH / 2, RR = RW / 2 - 8;
let rSweep = 0;
function drawRadar() {
  rCtx.clearRect(0, 0, RW, RH);
  rCtx.fillStyle = "#F3F0EA"; rCtx.beginPath(); rCtx.arc(RCX, RCY, RR, 0, Math.PI * 2); rCtx.fill();
  for (let i = 1; i <= 4; i++) { rCtx.strokeStyle = "rgba(217,119,6,0.08)"; rCtx.lineWidth = 1; rCtx.beginPath(); rCtx.arc(RCX, RCY, (RR / 4) * i, 0, Math.PI * 2); rCtx.stroke(); }
  rCtx.strokeStyle = "rgba(217,119,6,0.06)"; rCtx.beginPath(); rCtx.moveTo(RCX, RCY - RR); rCtx.lineTo(RCX, RCY + RR); rCtx.stroke(); rCtx.beginPath(); rCtx.moveTo(RCX - RR, RCY); rCtx.lineTo(RCX + RR, RCY); rCtx.stroke();
  const grad = rCtx.createConicGradient(rSweep - Math.PI / 2, RCX, RCY); grad.addColorStop(0, "rgba(217,119,6,0.2)"); grad.addColorStop(0.08, "rgba(217,119,6,0.06)"); grad.addColorStop(0.15, "rgba(217,119,6,0)"); grad.addColorStop(1, "rgba(217,119,6,0)"); rCtx.fillStyle = grad; rCtx.beginPath(); rCtx.arc(RCX, RCY, RR, 0, Math.PI * 2); rCtx.fill();
  const sx = RCX + RR * Math.cos(rSweep), sy = RCY + RR * Math.sin(rSweep); rCtx.strokeStyle = "rgba(217,119,6,0.5)"; rCtx.lineWidth = 1.5; rCtx.beginPath(); rCtx.moveTo(RCX, RCY); rCtx.lineTo(sx, sy); rCtx.stroke();
  rCtx.fillStyle = "#D97706"; rCtx.beginPath(); rCtx.arc(RCX, RCY, 3, 0, Math.PI * 2); rCtx.fill();
  rCtx.strokeStyle = "rgba(217,119,6,0.15)"; rCtx.lineWidth = 2; rCtx.beginPath(); rCtx.arc(RCX, RCY, RR, 0, Math.PI * 2); rCtx.stroke();
  rSweep += 0.015; if (rSweep > Math.PI * 2) rSweep -= Math.PI * 2;
  requestAnimationFrame(drawRadar);
}
drawRadar();

const deviceIcons = new Map<string, HTMLElement>();
function hashPos(id: string) { let h = 0; for (let i = 0; i < id.length; i++) { h = ((h << 5) - h) + id.charCodeAt(i); h |= 0; } return { angle: ((h & 0xFFFF) / 0xFFFF) * Math.PI * 2, radius: 0.3 + ((h >>> 16) & 0x7FFF) / 0x7FFF * 0.55 }; }

function updateRadarDevices(devices: Array<{ deviceId: string; ip: string; gatewayPort: number; [k: string]: unknown }>) {
  document.getElementById("lxDeviceCount")!.textContent = String(devices.length);
  const wrap = document.getElementById("lxRadarWrap")!;
  for (const d of devices) {
    if (deviceIcons.has(d.deviceId)) continue;
    const { angle, radius } = hashPos(d.deviceId);
    const x = RCX + RR * radius * Math.cos(angle), y = RCY + RR * radius * Math.sin(angle);
    const el = document.createElement("div");
    el.className = "lx-device-icon";
    el.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6v2H8v2h8v-2h-2v-2h6c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 12H4V6h16v10z"/></svg>';
    el.style.left = x + "px"; el.style.top = y + "px";
    const label = document.createElement("div"); label.className = "lx-device-label"; label.textContent = d.deviceId; el.appendChild(label);
    el.addEventListener("click", () => selectDevice(d));
    wrap.appendChild(el);
    requestAnimationFrame(() => el.classList.add("visible"));
    deviceIcons.set(d.deviceId, el);
  }
  for (const [id, el] of deviceIcons) {
    if (!devices.find(d => d.deviceId === id)) { el.classList.remove("visible"); setTimeout(() => el.remove(), 300); deviceIcons.delete(id); }
  }
}

async function selectDevice(device: { deviceId: string; ip: string; gatewayPort: number; [k: string]: unknown }) {
  // 未登录：先创建游客
  if (!isLoggedIn()) await ensureGuest();
  radarOverlay.classList.remove("show");
  // 通知 Electron 壳子绑定设备
  try { window.parent.postMessage({ type: "bind-device", device }, "*"); } catch {}
  // 未正式登录：弹登录框
  if (isGuest()) openLogin();
}

// ═══════════════════════════════════════
// Toast 通知组件
// ═══════════════════════════════════════
const toastContainer = document.createElement("div");
toastContainer.className = "lx-toast-container";
document.body.appendChild(toastContainer);

type ToastType = "success" | "error" | "info";
const TOAST_ICONS: Record<ToastType, string> = { success: "✅", error: "❌", info: "🔔" };

function showToast(opts: { title: string; message: string; type?: ToastType; duration?: number }) {
  const type = opts.type || "info";
  const el = document.createElement("div");
  el.className = `lx-toast lx-toast--${type}`;
  el.style.position = "relative";
  const now = new Date();
  const timeStr = `${now.getHours().toString().padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}`;
  el.innerHTML = `
    <div class="lx-toast-icon">${TOAST_ICONS[type]}</div>
    <div class="lx-toast-body">
      <div class="lx-toast-title">${opts.title}</div>
      <div class="lx-toast-msg">${opts.message}</div>
      <div class="lx-toast-time">${timeStr}</div>
    </div>
    <button class="lx-toast-close">✕</button>
  `;
  toastContainer.appendChild(el);
  // 进入动画
  requestAnimationFrame(() => el.classList.add("show"));
  // 关闭
  const close = () => { el.classList.remove("show"); el.classList.add("hide"); setTimeout(() => el.remove(), 400); };
  el.querySelector(".lx-toast-close")!.addEventListener("click", close);
  setTimeout(close, opts.duration || 5000);
}

// ── 暴露给侧边栏按钮使用 ──
(window as any).__lx = { openLogin, openRadar, confirmLogout, isLoggedIn, isGuest, updateUserUI, refreshCredits, hasCredits, getCreditsBalance, lxAlert, showToast };

// ── 页面加载时：已登录用户自动拉取积分 ──
if (isLoggedIn() && !isGuest()) {
  startCreditsPolling();
}

// ── 页面获得焦点时刷新积分（用户可能在其他端消耗了积分）──
window.addEventListener("focus", () => {
  if (isLoggedIn() && !isGuest()) refreshCredits();
});

// ── chat.send 前的登录检查（替代 postMessage 方式）──
// 这个在 controllers/chat.ts 中通过 ensureParentAuth 调用
// 现在改为直接在本窗口内弹登录框
